import { render, staticRenderFns } from "./Ceremonie.vue?vue&type=template&id=37dd3ccc"
import script from "./Ceremonie.vue?vue&type=script&lang=js"
export * from "./Ceremonie.vue?vue&type=script&lang=js"
import style0 from "./Ceremonie.vue?vue&type=style&index=0&id=37dd3ccc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports